// Generated by Melange

import * as Ppx_deriving_json_runtime from "melange-json.ppx-runtime/ppx_deriving_json_runtime.jsx";
import * as Subsonic__Genre from "./genre.jsx";
import * as Subsonic__ReplayGain from "./replayGain.jsx";

function of_json(x) {
  if (!(typeof x === "object" && !Array.isArray(x) && x !== null)) {
    Ppx_deriving_json_runtime.of_json_error("expected a JSON object");
  }
  const v = x.album;
  const v$1 = x.albumId;
  const v$2 = x.artist;
  const v$3 = x.artistId;
  const v$4 = x.coverArt;
  const v$5 = x.discNumber;
  const v$6 = x.duration;
  const v$7 = x.genre;
  const v$8 = x.genres;
  const v$9 = x.id;
  const v$10 = x.musicBrainzId;
  const v$11 = x.replayGain;
  const v$12 = x.size;
  const v$13 = x.starred;
  const v$14 = x.title;
  const v$15 = x.track;
  const v$16 = x.userRating;
  const v$17 = x.year;
  return {
    album: v !== undefined ? Ppx_deriving_json_runtime.Primitives.string_of_json(v) : Ppx_deriving_json_runtime.of_json_error("missing field \"album\""),
    albumId: v$1 !== undefined ? Ppx_deriving_json_runtime.Primitives.string_of_json(v$1) : Ppx_deriving_json_runtime.of_json_error("missing field \"albumId\""),
    artist: v$2 !== undefined ? Ppx_deriving_json_runtime.Primitives.string_of_json(v$2) : Ppx_deriving_json_runtime.of_json_error("missing field \"artist\""),
    artistId: v$3 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.string_of_json, v$3) : undefined,
    coverArt: v$4 !== undefined ? Ppx_deriving_json_runtime.Primitives.string_of_json(v$4) : Ppx_deriving_json_runtime.of_json_error("missing field \"coverArt\""),
    discNumber: v$5 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.int_of_json, v$5) : undefined,
    duration: v$6 !== undefined ? Ppx_deriving_json_runtime.Primitives.float_of_json(v$6) : Ppx_deriving_json_runtime.of_json_error("missing field \"duration\""),
    genre: v$7 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.string_of_json, v$7) : undefined,
    genres: v$8 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json((function (param) {
        return Ppx_deriving_json_runtime.Primitives.array_of_json(Subsonic__Genre.of_json, param);
      }), v$8) : undefined,
    id: v$9 !== undefined ? Ppx_deriving_json_runtime.Primitives.string_of_json(v$9) : Ppx_deriving_json_runtime.of_json_error("missing field \"id\""),
    musicBrainzId: v$10 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.string_of_json, v$10) : undefined,
    replayGain: v$11 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Subsonic__ReplayGain.of_json, v$11) : undefined,
    size: v$12 !== undefined ? Ppx_deriving_json_runtime.Primitives.float_of_json(v$12) : Ppx_deriving_json_runtime.of_json_error("missing field \"size\""),
    starred: v$13 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.string_of_json, v$13) : undefined,
    title: v$14 !== undefined ? Ppx_deriving_json_runtime.Primitives.string_of_json(v$14) : Ppx_deriving_json_runtime.of_json_error("missing field \"title\""),
    track: v$15 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.int_of_json, v$15) : undefined,
    userRating: v$16 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.float_of_json, v$16) : undefined,
    year: v$17 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.int_of_json, v$17) : undefined
  };
}

function to_json(x) {
  return {
    album: x.album,
    albumId: x.albumId,
    artist: x.artist,
    artistId: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.artistId),
    coverArt: x.coverArt,
    discNumber: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.discNumber),
    duration: x.duration,
    genre: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.genre),
    genres: Ppx_deriving_json_runtime.Primitives.option_to_json((function (param) {
      return Ppx_deriving_json_runtime.Primitives.array_to_json(Subsonic__Genre.to_json, param);
    }), x.genres),
    id: x.id,
    musicBrainzId: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.musicBrainzId),
    replayGain: Ppx_deriving_json_runtime.Primitives.option_to_json(Subsonic__ReplayGain.to_json, x.replayGain),
    size: x.size,
    starred: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.starred),
    title: x.title,
    track: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.track),
    userRating: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.userRating),
    year: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.year)
  };
}

export {
  of_json,
  to_json,
}
/* No side effect */
